import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const EmailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;

const Buttons = styled.div`
  ${AlignCenter}
  justify-content: flex-end;
  margin: var(--space-0);
  gap: var(--space-12);
  width: 100%;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  padding: var(--space-16);
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;

const Text = styled.label`
  color: var(--text-secondary);
  ${Typography.body_md_medium}
`;

const EmailName = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: var(--space-8);
`;

const Payment = styled.div`
  display: flex;
  gap: var(--space-12);
`;
const Check = styled.div`
  ${AlignCenter}
  width: 100%;
  p {
    color: var(--text-primary);
    ${Typography.body_md_medium}
    margin: var(--space-0);
  }
  a {
    color: var(--brand-primary);
    ${Typography.body_md_medium}
    cursor: pointer;
    text-decoration: none;
  }
  .label-checkbox {
    color: var(--text-secondary);
    ${Typography.body_md_medium}
    margin: var(--space-0);
    padding-left: var(--space-8);
  }
`;

const ButtonSection = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-20);
  `)}
`;

const Label = styled.label`
  color: var(--text-primary);
  ${Typography.body_md};
  padding-left: var(--space-8);
  margin: var(--space-0);
`;

const LabelSection = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
`;

const AddCCBlock = styled.button`
  background-color: transparent;
  border: none;
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  padding: var(--space-0);
  cursor: pointer;
  font-family: 'Inter';
`;

const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

export {
  Buttons,
  ModalContent,
  EmailSection,
  Text,
  EmailName,
  Payment,
  Check,
  ButtonSection,
  Label,
  LabelSection,
  AddCCBlock,
  InputSection
};
